
export default (element, reference) => {
    element._dotNetReference = reference;
    element.classList.add('dotNetReference');
};
